import { ApiClient } from "@modules/core/api/client/apiClient"
import { type SharedCoachApiGateway } from "@modules/sharedCoach/gateway/sharedCoachApiGateway"

export class SharedCoachApi implements SharedCoachApiGateway {
  constructor(private api: ApiClient) {}
  private programBaseUrl = "programs"

  async acceptSharedCoach(programId: string) {
    await this.api.post(`${this.programBaseUrl}/${programId}/shared-coach/accept`)
  }

  async refuseSharedCoach(programId: string) {
    await this.api.post(`${this.programBaseUrl}/${programId}/shared-coach/refuse`)
  }

  async quitSharedCoach(programId: string) {
    await this.api.post(`${this.programBaseUrl}/${programId}/shared-coach/quit`)
  }

  async removeSharedCoach(programId: string, coachId: string) {
    await this.api.delete(`${this.programBaseUrl}/${programId}/shared-coach/${coachId}`)
  }
}
